import { RESERVED_PATH_SEGMENTS } from '@/helpers/tenantSlug';

const STORAGE_KEY = 'sonny.onboarding.eventSlug';

export const EVENT_QUERY_PARAM = 'evento';

const EVENT_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{0,79}$/;

// URL pública do convite por EVENTO: https://foto.identila.com.br/<event-slug>
// (o slug do evento é globalmente único no service — uq_events_slug). O slug só
// vem do path neste host — em qualquer outro, o path continua sendo tenant/rota.
const EVENT_PUBLIC_HOSTNAME = 'foto.identila.com.br';

export type EventSlugLocation = {
  hostname: string;
  pathname: string;
  search: string;
};

export function normalizeEventSlug(value: string | null | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const slug = value.trim().toLowerCase();
  return EVENT_SLUG_PATTERN.test(slug) ? slug : null;
}

function slugFromQuery(search: string): string | null {
  return normalizeEventSlug(new URLSearchParams(search).get(EVENT_QUERY_PARAM));
}

// Primeiro segmento do path no host público: /<slug> (convite) e
// /<slug>/link/<token> (link único). Rotas do funil na raiz nunca são slug.
function slugFromPath(hostname: string, pathname: string): string | null {
  if (hostname.toLowerCase() !== EVENT_PUBLIC_HOSTNAME) {
    return null;
  }
  const [first] = pathname.split('/').filter((segment) => segment !== '');
  if (first === undefined || RESERVED_PATH_SEGMENTS.has(first.toLowerCase())) {
    return null;
  }
  return normalizeEventSlug(first);
}

/** Query (?evento=, dev/QR) tem precedência sobre o path (produção). */
export function resolveEventSlugFromLocation(location: EventSlugLocation): string | null {
  return slugFromQuery(location.search) ?? slugFromPath(location.hostname, location.pathname);
}

function canUseSessionStorage(): boolean {
  try {
    return typeof sessionStorage !== 'undefined';
  } catch {
    return false;
  }
}

export function setStoredEventSlug(slug: string): void {
  if (slug === '' || !canUseSessionStorage()) {
    return;
  }
  try {
    sessionStorage.setItem(STORAGE_KEY, slug);
  } catch {
    // Modo privado ou storage desabilitado — o slug segue valendo só para este load.
  }
}

export function getStoredEventSlug(): string | null {
  if (!canUseSessionStorage()) {
    return null;
  }
  try {
    return normalizeEventSlug(sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}
